import { Button, Popconfirm, Row, Space, Table, Typography } from 'antd';
import type { Moment } from 'moment';
import { WorkRecord } from '../../modules/work-records';
import moment from 'moment';
import { ColumnsType } from 'antd/lib/table';
import Title from 'antd/lib/typography/Title';
import styled from 'styled-components';
import { styledTable } from '../styled/mixin';

interface WorkRecordListComponentProps {
  workRecords: WorkRecord[];
  moveToDetailPage: (workRecordId: string) => void;
  moveToCreatePage: () => void;
  onDelete: (workRecordId: string) => void;
  onSelect: (newValue: Moment) => void;
}

const StyledDiv = styled.div`
  ${styledTable}
`;

function WorkRecordListComponent({
  workRecords,
  moveToCreatePage,
  moveToDetailPage,
  onDelete,
  onSelect,
}: WorkRecordListComponentProps) {
  console.log(workRecords);

  const columns: ColumnsType<WorkRecord> = [
    {
      title: '작성일',
      dataIndex: 'createdDate',
      width: '10%',
      sorter: (a: WorkRecord, b: WorkRecord) =>
        a.createdDate.localeCompare(b.createdDate),
      // render: (text: any, record: any, index: any) =>
      //   moment(record.createdDate).format('YYYY-MM-DD'),
      render: (text: any, record: any) => (
        <>
          <span
            className="clickable-table-item"
            onClick={() => moveToDetailPage('' + record.id)}
          >
            {moment(record.createdDate).format('YYYY-MM-DD')}
          </span>
        </>
      ),
    },
    {
      title: '작성자',
      ellipsis: true,
      width: '10%',
      // render: (text: any, record: any) => (
      //   <>
      //     <span
      //       className="clickable-table-item"
      //       onClick={() => moveToDetailPage('' + record.id)}
      //     >
      //       {text}
      //     </span>
      //   </>
      // ),
      render: (text: any, record: any) => <>{record.createdBy.name}</>,
    },
    {
      title: '첨부파일',
      width: '7%',
      render: (text: any, record: any, index: any) => `${record.file.length}개`,
    },
    {
      title: '금일 작업내용',
      width: '20%',
      ellipsis: true,
      render: (text: any, record: any, index: any) => (
        <Typography.Paragraph ellipsis={{ rows: 1 }} style={{ margin: '0px' }}>
          {record.todayNote}
        </Typography.Paragraph>
      ),
    },
    {
      title: '명일 예정사항',
      width: '20%',
      ellipsis: true,
      render: (text: any, record: any, index: any) => (
        <Typography.Paragraph ellipsis={{ rows: 1 }} style={{ margin: '0px' }}>
          {record.tomorrowNote}
        </Typography.Paragraph>
      ),
    },
    {
      title: '특이사항',
      width: '20%',
      ellipsis: true,
      render: (text: any, record: any, index: any) => (
        <Typography.Paragraph ellipsis={{ rows: 1 }} style={{ margin: '0px' }}>
          {`${record.issueNote}`}
        </Typography.Paragraph>
      ),
    },
    // {
    //   title: '공정',
    //   dataIndex: 'gongjong',
    //   ellipsis: true,
    //   render: (text: any, record: any) => <>{text === null ? '기타' : text}</>,
    //   sorter: (a: Task, b: Task) =>
    //     a.gongjong === null || b.gongjong === null
    //       ? -1
    //       : a.gongjong.localeCompare(b.gongjong),
    //   width: '7%',
    // },

    {
      title: '',
      key: 'action',
      dataIndex: '',
      align: 'center',
      width: '7%',
      render: (text, record, index) => (
        <Space size="small">
          <div onClick={(e) => e.stopPropagation()}>
            <Popconfirm
              title="정말 삭제하시겠습니까?"
              data-test={`project-list-item-${index}`}
              onConfirm={() => onDelete('' + record.id)}
            >
              <Button size="small">삭제</Button>
            </Popconfirm>
          </div>
        </Space>
      ),
    },
  ];

  return (
    <StyledDiv>
      <Row justify="space-between">
        <Title level={3}>작업일보 리스트</Title>
        <Button onClick={() => moveToCreatePage()} size="small">
          생성
        </Button>
      </Row>
      {workRecords && (
        <Table<WorkRecord>
          rowKey="id"
          columns={columns}
          dataSource={workRecords}
          pagination={{
            defaultPageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30', '50', '100', '300'],
            position: ['bottomCenter'],
          }}
          locale={{
            triggerDesc: '내림차순으로 정렬하려면 클릭하세요.',
            triggerAsc: '오름차순으로 정렬하려면 클릭하세요.',
            cancelSort: '정렬을 취소하려면 클릭하세요.',
          }}
        />
      )}
    </StyledDiv>
  );
}

export default WorkRecordListComponent;
